module.exports = __webpack_public_path__ + "img/visa.15083ee9.png";